import React from 'react';

const GlobalSettingsPage = React.lazy(() => import('pages/global-settings'));
const GlobalSettingsGeneralPage = React.lazy(() => import('pages/global-settings/general'));
const GlobalTrendsPage = React.lazy(() => import('pages/global-settings/trends'));
const ROIVariables = React.lazy(() => import('pages/global-settings/roi-variables'));
const GlobalSettingsTermsPage = React.lazy(() => import('pages/global-settings/terms'));
const GlobalSettingsProductSourcesPage = React.lazy(() => import('pages/global-settings/product-sources'));
const GlobalSettingsVarietalsPage = React.lazy(() => import('pages/global-settings/varietals'));
const GlobalSettingsSalesGroupsPage = React.lazy(() => import('pages/global-settings/sales-groups'));
const GlobalSettingsParLevelsPage = React.lazy(() => import('pages/global-settings/par-levels'));
const GlobalSettingsPermissionsPage = React.lazy(() => import('pages/global-settings/permissions'));
const GlobalSettingsFulfilmentHubPage = React.lazy(() => import('pages/global-settings/fulfilment-hub'));
const GlobalSettingsBCWebhooksPage = React.lazy(() => import('pages/global-settings/bc-webhooks'));
const GlobalSettingsBCCategoriesPage = React.lazy(() => import('pages/global-settings/bc-categories'));

const policies = [{ resource: 'globalSettings', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <GlobalSettingsPage />
  },
  {
    path: 'general',
    policies: policies,
    component: <GlobalSettingsGeneralPage />
  },
  {
    path: 'terms',
    policies: policies,
    component: <GlobalSettingsTermsPage />
  },
  {
    path: 'product-sources',
    policies: policies,
    component: <GlobalSettingsProductSourcesPage />
  },
  {
    path: 'varietals',
    policies: policies,
    component: <GlobalSettingsVarietalsPage />
  },
  {
    path: 'roi-variables',
    policies: policies,
    component: <ROIVariables />
  },
  {
    path: 'trends',
    policies: policies,
    component: <GlobalTrendsPage />
  },
  {
    path: 'sales-groups',
    policies: policies,
    component: <GlobalSettingsSalesGroupsPage />
  },
  {
    path: 'permissions',
    policies: policies,
    component: <GlobalSettingsPermissionsPage />
  },
  {
    path: 'fulfilment-hub',
    policies: policies,
    component: <GlobalSettingsFulfilmentHubPage />
  },
  {
    path: 'bc-webhooks',
    policies: policies,
    component: <GlobalSettingsBCWebhooksPage />
  },
  {
    path: 'bc-categories',
    policies: policies,
    component: <GlobalSettingsBCCategoriesPage />
  }
];
